import { AnimatePresence, motion } from 'framer-motion'
import { useState } from 'react'
import styled from 'styled-components'
import { MapAppeal } from '../../../api/service/request.service'
import useWindowWidth from '../../../utils/use.window.width'

const Card = styled.div`
	border-radius: 18px;
	box-shadow: 0 4px 4px 0 rgba(0, 0, 0, 0.25);
	background: #f8f8f8;
	overflow: hidden;
`

const CardTop = styled.div`
	display: flex;
	align-items: center;
	gap: 24px;
	padding: 14px 22px 10px;

	@media (max-width: 1024px) {
		gap: 6px;
	}

	@media (max-width: 768px) {
		padding: 12px 16px 8px;
	}
	@media (max-width: 530px) {
		align-items: start;
		flex-direction: column;
	}
`

const CardColLeft = styled.div`
	display: flex;
	flex-direction: column;
	gap: 6px;
	min-width: 200px;
	flex-shrink: 0;

	@media (max-width: 1024px) {
		min-width: 165px;
	}

	@media (max-width: 768px) {
		align-items: baseline;
		gap: 10px;
		min-width: 200px;
	}
`

const CardNumber = styled.div`
	font-family: 'e-Ukraine', sans-serif;
	font-weight: 400;
	font-size: 15px;
	color: #000;

	@media (max-width: 530px) {
		font-size: 13px;
	}
`

const CardDate = styled.div`
	font-family: 'e-Ukraine', sans-serif;
	font-size: 11px;
	color: #aaa;

	@media (max-width: 530px) {
		color: #555;
	}
`

const CardColCenter = styled.div`
	flex: 1;
	min-width: 0;
	display: flex;
	flex-direction: column;
	gap: 6px;
	max-width: 1060px;

	@media (max-width: 768px) {
		width: 100%;
		flex: unset;
	}
`

const CardProblem = styled.div`
	font-family: 'e-Ukraine', sans-serif;
	font-weight: 400;
	font-size: 15px;
	color: #494a4c;

	@media (max-width: 530px) {
		font-size: 12px;
	}
`

const CardDesc = styled.div`
	font-family: 'e-Ukraine', sans-serif;
	font-weight: 400;
	font-size: 14px;
	color: #777;

	@media (max-width: 768px) {
		padding: 15px 15px 0 15px;
	}

	@media (max-width: 530px) {
		font-size: 12px;
	}
`

const CardColRight = styled.div`
	flex-shrink: 0;
	display: flex;
	justify-content: end;

	@media (max-width: 768px) {
		width: 100%;
		justify-content: flex-end;
	}
`

const DetailBtn = styled.button<{ $open: boolean }>`
	font-family: 'e-Ukraine', sans-serif;
	font-weight: 300;
	font-size: 11px;
	text-transform: lowercase;
	color: #8f8f8f;
	background: none;
	border: none;
	cursor: pointer;
	display: flex;
	align-items: center;
	gap: 4px;
	padding: 0;
	white-space: nowrap;
	margin-top: 20px;

	svg {
		transition: transform 0.3s ease;
		transform: ${({ $open }) => ($open ? 'rotate(180deg)' : 'rotate(0deg)')};
	}
`

const CardDetailsInner = styled.div`
	padding: 10px 16px 0;
`

const DetailsTopRow = styled.div`
	display: flex;
	gap: 40px;
	margin-bottom: 24px;
	flex-wrap: wrap;

	@media (max-width: 1024px) {
		gap: 6px;
	}

	@media (max-width: 530px) {
		flex-direction: column;
		gap: 16px;
		margin-bottom: 16px;
	}
`

const DetailInfoCol = styled.div`
	display: flex;
	flex-direction: column;
	gap: 6px;
	min-width: 200px;

	@media (max-width: 1024px) {
		min-width: 165px;
	}

	@media (max-width: 768px) {
		min-width: 200px;
	}
`

const DetailMiniLabel = styled.div`
	font-family: 'e-Ukraine', sans-serif;
	font-weight: 400;
	font-size: 13px;
	color: #8f8f8f;

	@media (max-width: 530px) {
		font-size: 11px;
	}
`

const DetailMiniValue = styled.div`
	font-family: 'e-Ukraine', sans-serif;
	font-weight: 400;
	font-size: 15px;
	color: #000;

	@media (max-width: 530px) {
		font-size: 13px;
	}
`

const BadgeMetaRow = styled.div`
	display: flex;
	align-items: end;
	margin: 0 -16px;

	@media (max-width: 768px) {
		align-items: start;
		flex-direction: column-reverse;
	}
`

const DetailMetaRow = styled.div`
	display: flex;
	flex-wrap: wrap;
	padding: 8px 40px;
	flex: 1;
	align-items: center;
	gap: 10px;

	@media (max-width: 768px) {
		padding: 12px 16px;
		gap: 12px 0;
	}
`

const DetailMetaCol = styled.div<{ $statusId: number }>`
	display: flex;
	flex-direction: column;
	gap: 4px;
	padding-right: 24px;
	padding-left: 14px;
	margin-right: 16px;
	position: relative;

	&::before {
		content: '';
		position: absolute;
		left: 0;
		top: 0;
		bottom: 0;
		width: 2px;
		background: ${({ $statusId }) => ($statusId === 1 ? '#f5a623' : '#01924f')};
		border-radius: 2px;
	}

	@media (max-width: 530px) {
		padding-left: 10px;
		padding-right: 16px;
		margin-right: 0;
		width: 100%;
	}
`

const DetailMetaLabel = styled.div`
	font-family: 'e-Ukraine', sans-serif;
	font-weight: 400;
	font-size: 11px;
	text-transform: lowercase;
	color: #8f8f8f;
`

const DetailMetaValue = styled.div`
	font-family: 'e-Ukraine', sans-serif;
	font-weight: 400;
	font-size: 12px;
	color: #555;
`
export const DetailsTabletContainer = styled.div`
	@media (max-width: 768px) {
		display: flex;
		justify-content: space-between;
		align-items: center;
		width: 95%;
	}
`

export const StatusBadgeContainer = styled.div`
	position: relative;
	display: block;
	width: 210px;
	height: 55px;
	flex-shrink: 0;
`

const StatusBadgeSVG: React.FC<{ statusId: number }> = ({ statusId }) => {
	const color = statusId === 1 ? '#f5a623' : '#01924f'
	const badgeLabel = statusId === 1 ? 'В роботі' : 'Опрацьовано'

	return (
		<StatusBadgeContainer>
			<svg
				width='210'
				height='55'
				viewBox='0 0 210 55'
				fill='none'
				xmlns='http://www.w3.org/2000/svg'
				style={{ display: 'block' }}
			>
				<path
					d='M0 19.16V8.33V0.92C0 -0.0190907 1.24283 -0.352841 1.71327 0.459916L6.26866 8.33L7.33786 10.1772C10.5558 15.7367 16.4927 19.16 22.9164 19.16H25.0746H37.6119H192C201.941 19.16 210 27.2189 210 37.16V39.68V43.1V45.665V48.23V49.7975V51.365V52.9325V54.5H18C8.05887 54.5 0 46.4411 0 36.5V19.16Z'
					fill={color}
				/>
			</svg>
			<span
				style={{
					position: 'absolute',
					bottom: 10,
					left: 0,
					right: 0,
					textAlign: 'center',
					fontFamily: "'e-Ukraine', sans-serif",
					fontWeight: 700,
					fontSize: 12,
					letterSpacing: '0.04em',
					textTransform: 'uppercase',
					color: '#fff',
				}}
			>
				{badgeLabel}
			</span>
		</StatusBadgeContainer>
	)
}

export const AppealCardItem: React.FC<{ appeal: MapAppeal }> = ({ appeal }) => {
	const [open, setOpen] = useState(false)
	const windowWidth = useWindowWidth()
	const isTablet = windowWidth <= 768

	const formatDate = (dateStr: string | null) => {
		if (!dateStr) return '—'
		return new Date(dateStr).toLocaleDateString('uk-UA', {
			day: '2-digit',
			month: '2-digit',
			year: 'numeric',
		})
	}

	const hasDetails =
		appeal.executor || appeal.datePlan || appeal.finalDate || appeal.streetName

	return (
		<Card>
			<CardTop>
				<CardColLeft>
					<CardNumber>Звернення № {appeal.requestNum}</CardNumber>
					<CardDate>від {formatDate(appeal.createdDate)}</CardDate>
				</CardColLeft>

				<CardColCenter>
					<CardProblem>{appeal.problemName}</CardProblem>
					{!isTablet && <CardDesc>{appeal.reasonName}</CardDesc>}
				</CardColCenter>

				{!isTablet && (
					<CardColRight>
						{hasDetails && (
							<DetailBtn $open={open} onClick={() => setOpen(v => !v)}>
								детальніше
								<svg width='10' height='6' viewBox='0 0 10 6' fill='none'>
									<path
										d='M1 1L5 5L9 1'
										stroke='#8f8f8f'
										strokeWidth='1.5'
										strokeLinecap='round'
									/>
								</svg>
							</DetailBtn>
						)}
					</CardColRight>
				)}
			</CardTop>
			{isTablet && <CardDesc>{appeal.reasonName}</CardDesc>}

			<DetailsTabletContainer>
				<motion.div
					animate={{ opacity: open ? 0 : 1 }}
					transition={{ duration: 0.2 }}
					style={{ pointerEvents: open ? 'none' : 'auto' }}
				>
					<StatusBadgeSVG statusId={appeal.statusId} />
				</motion.div>

				{hasDetails && !open && isTablet && (
					<DetailBtn $open={open} onClick={() => setOpen(v => !v)}>
						детальніше
						<svg width='10' height='6' viewBox='0 0 10 6' fill='none'>
							<path
								d='M1 1L5 5L9 1'
								stroke='#8f8f8f'
								strokeWidth='1.5'
								strokeLinecap='round'
							/>
						</svg>
					</DetailBtn>
				)}
			</DetailsTabletContainer>

			{/* Детали */}
			<AnimatePresence initial={false}>
				{open && (
					<motion.div
						key='details'
						initial={{ height: 0, opacity: 0 }}
						animate={{ height: 'auto', opacity: 1 }}
						exit={{ height: 0, opacity: 0 }}
						transition={{ duration: 0.3, ease: [0.4, 0, 0.2, 1] }}
						style={{ overflow: 'hidden' }}
					>
						<CardDetailsInner>
							<DetailsTopRow>
								{appeal.status && (
									<DetailInfoCol>
										<DetailMiniLabel>Статус:</DetailMiniLabel>
										<DetailMiniValue>{appeal.status}</DetailMiniValue>
									</DetailInfoCol>
								)}
								{(appeal.streetName || appeal.houseNum) && (
									<DetailInfoCol>
										<DetailMiniLabel>Адреса:</DetailMiniLabel>
										<DetailMiniValue>
											{[appeal.streetName, appeal.houseNum]
												.filter(Boolean)
												.join(', ')}
										</DetailMiniValue>
									</DetailInfoCol>
								)}
							</DetailsTopRow>

							<BadgeMetaRow>
								<DetailsTabletContainer>
									<StatusBadgeSVG statusId={appeal.statusId} />
									{isTablet && open && hasDetails && (
										<DetailBtn $open={open} onClick={() => setOpen(v => !v)}>
											детальніше
											<svg width='10' height='6' viewBox='0 0 10 6' fill='none'>
												<path
													d='M1 1L5 5L9 1'
													stroke='#8f8f8f'
													strokeWidth='1.5'
													strokeLinecap='round'
												/>
											</svg>
										</DetailBtn>
									)}
								</DetailsTabletContainer>
								<DetailMetaRow>
									{appeal.datePlan && (
										<DetailMetaCol $statusId={appeal.statusId}>
											<DetailMetaLabel>планова дата виконання:</DetailMetaLabel>
											<DetailMetaValue>
												{formatDate(appeal.datePlan)}
											</DetailMetaValue>
										</DetailMetaCol>
									)}
									{appeal.finalDate && (
										<DetailMetaCol $statusId={appeal.statusId}>
											<DetailMetaLabel>дата закриття:</DetailMetaLabel>
											<DetailMetaValue>
												{formatDate(appeal.finalDate)}
											</DetailMetaValue>
										</DetailMetaCol>
									)}
									{appeal.executor && (
										<DetailMetaCol $statusId={appeal.statusId}>
											<DetailMetaLabel>виконавець:</DetailMetaLabel>
											<DetailMetaValue>{appeal.executor}</DetailMetaValue>
										</DetailMetaCol>
									)}
								</DetailMetaRow>
							</BadgeMetaRow>
						</CardDetailsInner>
					</motion.div>
				)}
			</AnimatePresence>
		</Card>
	)
}
